module.exports = __webpack_public_path__ + "img/puberty-decal-00.4d11ccce.png";